import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=8de12aca&scoped=true&"
import script from "./blog.vue?vue&type=script&lang=js&"
export * from "./blog.vue?vue&type=script&lang=js&"
import style0 from "./blog.vue?vue&type=style&index=0&id=8de12aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de12aca",
  null
  
)

export default component.exports